import classnames from "classnames";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption, InputFilterOption } from "web/types/universal-filters";
import styles from "./checkbox-filter-item.css";

interface CheckboxFilterItemProps extends StandardFilterProps {
    item: InputFilterOption | CategoryFilterOption;
    isSmallItem?: boolean;
    hasChildren?: boolean;
    ariaControls?: string;
    siblingOpen?: boolean;
}

const CheckboxFilterItem = function CheckboxFilterItem({
    ariaControls,
    isSmallItem,
    item,
    onClick,
    pendingFilterInfo,
    hasChildren,
    siblingOpen,
}): JSX.Element {
    const isCategoryHeading = item.type == "category";
    const isRadioButton = item.type == "radio";

    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        onClick(item);
    }

    let checked = pendingFilterInfo.getChecked(item);

    let showArrow = hasChildren;

    return (
        <a
            href={item.url}
            className={classnames(styles.filterItem, {
                [styles.selectedLabel]: checked,
                [styles.smallFilterItem]: isSmallItem,
                [styles.siblingOpen]: siblingOpen && !checked,
            })}
            onClick={handleClick}
            role="button"
            aria-expanded={hasChildren ? checked : undefined}
            aria-controls={hasChildren ? ariaControls : undefined}
        >
            <div className={styles.icon}>
                {isCategoryHeading || isRadioButton ? (
                    checked ? (
                        <SVGIcon name={"round-radiobutton-checked"} />
                    ) : (
                        <SVGIcon name={"round-radiobutton"} />
                    )
                ) : checked ? (
                    <SVGIcon name={"round-checkbox-checked"} />
                ) : (
                    <SVGIcon name={"round-checkbox"} />
                )}
            </div>
            <span className={styles.labelItem}>{item.label}</span>
            {showArrow && (isCategoryHeading || isRadioButton) && (
                <SVGIcon
                    className={classnames(styles.arrow, { [styles.rotate]: checked })}
                    name="round-chevron"
                />
            )}
        </a>
    );
} as React.FC<CheckboxFilterItemProps>;

export default CheckboxFilterItem;

CheckboxFilterItem.defaultProps = {
    isSmallItem: false,
};
